define.alias("shared/components/shared/referral-promo-banner", "calendar/components/shared/referral-promo-banner");